/* eslint-disable jsx-a11y/alt-text */
import { useAuth0 } from "@auth0/auth0-react";
import Avatar from "@material-ui/core/Avatar";
import Dialog from "@material-ui/core/Dialog";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import Pagination from "@material-ui/lab/Pagination";
import Tooltip from "@mui/material/Tooltip";
import AuthService from "Lib/API/Auth";
import { Text } from "components";
import Action from "components/ActionPopOver";
import AlertDialog from "components/Dialog";
import NewDialog from "components/NewDialog/Dialog";
import Button from "components/button/Button";
import RightDrawer from "components/drawer";
import Loader from "components/loader/Loader";
import { formatDate } from "helper";
import * as _ from "lodash";
import moment from "moment";
import AddMourner from "pages/Yaherzit/AddMourner/AddMourner";
import AddDeceased from "pages/Yaherzit/NewYahrzeit";
import YahrzietDrawer from "pages/Yaherzit/YahrzietDrawer";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory, useParams } from "react-router-dom";
import { DateFormetContext } from "../../../../app/App.js";
import MyButton from "../../../../components/MyButton";
import MyTable from "../../../../components/Table";
import "../../../Yaherzit/yaherzitStyle.scss";
import DeceasedTableList from "./DeceasedTableList.jsx";
import "./style.scss";

const DeceasedTable = ({ setRefresh, member, refresh }) => {
  const { id } = useParams();
  const history = useHistory();
  const {state} = history.location || {};

  const dateFormet = React.useContext(DateFormetContext);
  const [openModal, setOpenModal] = React.useState(false);
  const [openDiscardChanges, setOpenDiscardChanges] = React.useState(false);
  const [list, setList] = React.useState([]);
  const [deceasedId, setDeceasedId] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [touched, setTouched] = React.useState({});
  const [page, setPage] = React.useState(0);
  const [total, setTotal] = React.useState(0);
  const [data, setData] = React.useState({});
  const rowsPerPage = 15;
  const { getAccessTokenSilently } = useAuth0();
  const [isOpenMergePopUp, setIsOpenMergePopUp] = useState(false);
  const [message, setMessage] = useState("");
  const [loadingMerge, setLoadingMerge] = useState(false);
  const [addMournerSuccess, setAddMournerSuccess] = useState(false);
  const [openAddMournerModal, setOpenAddMournerModal] = React.useState(false);
  const [openAddMournerSource, setOpenAddMournerSource] = React.useState("table");
  const [mournersList, setMournersList] = React.useState([]);
  const [confirmClose, setConfirmClose] = useState(false);
    const [selectedMourner, setSelectedMourner] = React.useState(null);
    const [manageMournerType, setManageMournerType] = React.useState("create");
  const handleClose = () => {
    if (_.isEmpty(touched)) setOpenModal(false);
    else setOpenDiscardChanges(true);
  };

  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    async function fetchMyAPI() {
      setLoading(true);
      const token = await getAccessTokenSilently();
      AuthService.getDeceasedByMemberId(page + 1, 30, id, token)
        .then((res) => {
          setLoading(false);
          setList(res?.deceaseds);
          setTotal(res?.total);
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
          setLoading(false);
        });
    }
    fetchMyAPI();
  }, [page]);

  useEffect(() => {
    if(!state || !state?.openCreateYahrzeit) return;
    setIsOpenMergePopUp(true);


  }, [state]);

  const clearHistoryState = () => {
    history.replace({ ...history.location, state: { 
      activeTab: "Yahrzeits",
      openCreateYahrzeit: false
    } });
  }

  useEffect(() => {
    if(!isOpenMergePopUp && !state?.openCreateYahrzeit) return;
    clearHistoryState();

  }, [isOpenMergePopUp]);

  const handleDelete = async () => {
    setRefresh(false);
    const token = await getAccessTokenSilently();
    await AuthService.removeDeceased({ deceasedID: deceasedId }, token)
      .then((res) => {
        if (res) {
          setOpen(false);
          setRefresh(true);
        }
      })
      .catch((err) => {});
  };
  
  const openAddMournerModalHandler = (mourners, type = "create", selectedMourner) => {
    setOpenAddMournerModal(true);
    setOpenAddMournerSource("drawer");
    const filteredMourner = mourners.map((item) => {
      return {
        ...item,
        memberId: item?._id,
      };
    });
    setMournersList(filteredMourner);
    setSelectedMourner(selectedMourner);
    setManageMournerType(type);
  }

  const closeOpenAddMournerModalHandler = () => {
    setOpenAddMournerModal(false);
    setOpenAddMournerSource("table");
    setMournersList([]);
    setSelectedMourner(null);
    setManageMournerType("create");
  }

  const closeModal = () => {
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setIsOpenMergePopUp(false);
  }

  return (
    <div className="family-table-container member-yahrzeit-table position-relative">
      <div className="my-auto page-header">
        <Text className="sub-title">Yahrzeit</Text>
        <Button
            variant="primary"
            onClick={() => setIsOpenMergePopUp(true)}
            style={{ width: "150px", marginLeft: 10, marginRight: "3rem" }}
          >
          Add Yahrzeit
        </Button>
      </div>
      <DeceasedTableList 
        list={list}
        loading={loading}
        total={total}
        setPage={setPage}
        setOpenModal={setOpenModal}
        setOpen={setOpen}
        setMournersList={setMournersList}
        setDeceasedId={setDeceasedId}
        setOpenAddMournerModal={setOpenAddMournerModal}
      />

      <RightDrawer open={openModal} onClose={handleClose}>
        <YahrzietDrawer
          open={openDiscardChanges}
          setOpen={setOpenDiscardChanges}
          setOpenAlert={setOpen}
          setTouched={setTouched}
          setOpenDrawer={setOpenModal}
          deceasedId={deceasedId}
          refresh={refresh}
          setRefresh={setRefresh}
          isEdit={"true"}
          openAddMournerModal={openAddMournerModalHandler}
          addMournerSuccess={addMournerSuccess}
          setAddMournerSuccess={setAddMournerSuccess}
        />
      </RightDrawer>
      <AlertDialog
        open={open}
        handleClose={() => setOpen(false)}
        onDecline={() => {
          setOpen(false);
        }}
        onAccept={handleDelete}
        title={"Are you sure?"}
        description={"Do you want to delete this deceased?"}
      />

      <NewDialog
        isOpen={isOpenMergePopUp}
        message={message}
        handleClose={closeModal}
        loading={loadingMerge}
        title={"New Yahrzeit"}
        sx={{
          "& .MuiDialog-paperWidthSm": { minWidth: "997.01px", height: "97%" },
        }}
        content={
          <div className="dialog-wrapper">
            <AddDeceased
              isOpenMergePopUp={isOpenMergePopUp}
              setRefresh={setRefresh}
              refresh={refresh}
              closeModal={() => {
                setIsOpenMergePopUp(false);
              }}
            />
          </div>
        }
        contentStyle={{
          display: "flex",
          justifyContent: "center",
          height: "100%",
        }}
        buttonStyle={{ justifyContent: "right" }}
      ></NewDialog>
       <Dialog
        open={openAddMournerModal}
        onClose={closeOpenAddMournerModalHandler}
        PaperProps={{
          style: {
            width: "450px",
            height: "570px",
            overflowX: "hidden",
            borderRadius: "22px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      >
        <AddMourner  
          deceasedId={deceasedId}
          onAddSuccess={() => {
            if(openAddMournerSource === "drawer"){
              setAddMournerSuccess(true);
              setOpenAddMournerModal(false);
              setRefresh(!refresh);
            }
            setOpenAddMournerModal(false);
          }}
          closeModal={closeOpenAddMournerModalHandler}
          selectedMourners={mournersList || []}
          selectedMourner={selectedMourner}
          type={manageMournerType}
        />
      </Dialog>
      <AlertDialog
        open={confirmClose}
        handleClose={() => setConfirmClose(false)}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </div>
  );
};

export default DeceasedTable;
